import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { Typography } from 'antd';

import './recacheIntervalCaption.css';
import { useEvent } from '../events/hooks/useEvent';

const { Link, Text } = Typography;

export default function RecacheIntervalCaption({ prerenderUser }) {
  const navigate = useNavigate();
  const { track } = useEvent();
  const isCustomPrice = useMemo(() => typeof prerenderUser?.customPrice === 'number', [prerenderUser]);

  return (
    <div className="col recache-interval-caption">
      <Text>Choose how regularly your site's pages are recached to ensure content freshness. </Text>
      <Link
        href="https://docs.prerender.io/docs/cache-expiration"
        onClick={() => {
          track('Recache settings learn more link clicked', {
            subscription_plan: prerenderUser?.chargebeePlanId,
          });
        }}
        target="_blank"
        rel="noreferrer"
      >
        Learn more
      </Link>
      {!isCustomPrice && (
        <>
          <Text> or </Text>
          <Link
            onClick={() => {
              track('Recache settings upgrade link clicked', {
                subscription_plan: prerenderUser?.chargebeePlanId,
              });
              navigate('/billing/plans');
            }}
          >
            upgrade your plan
          </Link>
        </>
      )}
      <Text>.</Text>
    </div>
  );
}
